module.exports = __webpack_public_path__ + "static/media/dominique-crenn-AD-6.76771616.jpg";